export { default } from './part-services-decor';
